import { useContext } from 'react'

import { useDecomposeMediaActionStrategicMutation } from '@/common/api/modules/mediaAction'
import { MediaAction } from '@/common/model/media/mediaAction'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'

import { DecomposeResultModalContext } from '@/components/container/modal/automationReview/DecomposeResultModalProvider'
import { ConfirmDialogContext } from '@/components/container/modal/dialog/confirm/ConfirmDialogProvider'

interface Props {
  siteId: number
  action: MediaAction
  onChanged(): void
}

// 戦略アクションをAIで具体アクションに分解するボタン
const MediaActionDecomposeButton = ({ siteId, action, onChanged }: Props) => {
  const { showModal: showConfirm, hide: hideConfirm } = useContext(ConfirmDialogContext)
  const { showModal: showResult } = useContext(DecomposeResultModalContext)

  const { trigger: decompose, isMutating: running } = useDecomposeMediaActionStrategicMutation({
    onSuccess: (data) => {
      showResult({ result: data.meta })
      onChanged()
    }
  })

  const handleClick = () =>
    showConfirm({
      message:
        `戦略アクション「${action.title}」を AI で具体アクションに分解します。\n\n` +
        '・Claude AI が 2〜5 件の実行可能なアクション（記事作成・リライト・内部リンク等）に分解\n' +
        '・分解された子アクションは「提案中」タブに追加されます\n' +
        '・元の戦略アクションは「完了」へ移動します\n\n実行しますか？',
      noText: 'キャンセル',
      yesText: '分解する',
      onClickYes: async () => {
        await decompose({ site_id: siteId, action_id: action.id }).catch(() => undefined)
        hideConfirm()
      }
    })

  return (
    <Button color={ButtonColor.PRIMARY_BRAND} loading={running} onClick={handleClick}>
      {running ? 'AI分解中...' : 'AIで具体アクションに分解'}
    </Button>
  )
}

export default MediaActionDecomposeButton
